<template>
  <div class="ai-exam-container">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="手动组卷" name="manual">
        <!-- 筛选与知识点 -->
        <el-card class="filter-card">
          <div class="filter-title-row">
            <el-input v-model="examTitle" placeholder="请输入考试名称" class="filter-select"></el-input>
          </div>
          <div class="filter-row">
            <el-select v-model="typevalue" multiple placeholder="请选择类型" class="filter-select">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="value1" multiple placeholder="请选择教材" class="filter-select">
              <el-option v-for="item in textbookOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="value2" multiple collapse-tags placeholder="请选择科目" class="filter-select">
              <el-option v-for="item in suboptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="value3" multiple collapse-tags placeholder="请选择年级" class="filter-select">
              <el-option v-for="item in gradeoptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-button type="primary" round @click="fetchKnowledgeOptions" class="filter-btn">获取知识点</el-button>
            <el-button type="primary" round @click="handlestem" class="filter-btn">录入题目</el-button>
            <el-button type="primary" round @click="inputstem" class="filter-btn">手动输入题目</el-button>
          </div>
          <div class="filter-row">
            <el-select v-model="value4" multiple collapse-tags placeholder="请选择知识点" class="filter-select">
              <el-option v-for="item in knowledgeoptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-button @click="testget" type="primary" round class="filter-btn">获取题目列表</el-button>
          </div>
          <el-select v-model="value5" multiple collapse-tags placeholder="请选择班级" class="filter-select">
            <el-option v-for="item in classlist" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-date-picker
            v-model="examTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-ddTHH:mm:ss"
            class="filter-select"
          />
        </el-card>

        <!-- 题目表格区 -->
        <div class="table-flex-row">
          <el-card class="table-card">
            <!-- 筛选题目类型下拉框 -->
            <el-select v-model="filterQuType" placeholder="筛选题目类型" style="width: 160px; margin-bottom: 10px;">
              <el-option :label="'全部类型'" :value="''" />
              <el-option v-for="item in quTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <div class="table-title">所有题目</div>
            <el-table ref="multipleTable" :data="filteredTableData" tooltip-effect="dark" style="width: 100%"
              @selection-change="handleSelectionChange" height="420">
              <el-table-column type="selection" width="55" />
              <el-table-column label="类型" width="120">
                <template slot-scope="scope">{{ scope.row.quType }}</template>
              </el-table-column>
              <el-table-column prop="content" label="题目内容" width="400" />
              <el-table-column prop="chapter" label="章节" show-overflow-tooltip />
            </el-table>
          </el-card>
          <el-card class="table-card">
            <div class="table-title">选中的题目</div>
            <el-table ref="selectedTable" :data="selectedTableData" tooltip-effect="dark" style="width: 100%" height="420">
              <el-table-column label="类型" width="120">
                <template slot-scope="scope">{{ scope.row.quType }}</template>
              </el-table-column>
              <el-table-column prop="content" label="题目内容" width="400" />
              <el-table-column prop="chapter" label="章节" show-overflow-tooltip />
            </el-table>
            <!-- 统计行：显示各类型题目数量 -->
            <div class="selected-type-counts" style="margin-top: 10px; color: #409EFF;">
              <span v-for="type in quTypeOptions" :key="type.value" style="margin-right: 20px;">
                {{ type.label }}：{{ getSelectedTypeCounts()[type.value] }}题
              </span>
            </div>
          </el-card>
        </div>

        <!-- 悬浮按钮区 -->
        <div class="button-float">
          <el-button @click="uploadexamquestion" type="primary" size="large" round>发布并通知</el-button>
          <el-button @click="printTableToPdf" type="success" size="large" round>保存并下载word</el-button>
          <el-button @click="toggleSelection()" type="warning" size="large" round>取消选择</el-button>
          <el-button type="primary" round size="large" @click="convertAI">转AI</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="随机组卷" name="random">
        <el-card class="filter-card">
          <div class="filter-title-row">
            <el-input v-model="randomExamTitle" placeholder="请输入考试名称" class="filter-select"></el-input>
          </div>
          <div class="filter-row">
            <el-select v-model="randomTypeValue" placeholder="请选择类型" class="filter-select">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="randomValue1" placeholder="请选择教材" class="filter-select">
              <el-option v-for="item in textbookOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="randomValue2" placeholder="请选择科目" class="filter-select">
              <el-option v-for="item in suboptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="randomValue3" placeholder="请选择年级" class="filter-select">
              <el-option v-for="item in gradeoptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-model="randomValue5" placeholder="请选择班级" class="filter-select">
              <el-option v-for="item in classlist" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-button type="primary" round @click="fetchRandomKnowledgeOptions" class="filter-btn">获取知识点</el-button>
          </div>
          <!-- <div class="filter-row">
            <el-select v-model="randomValue5" multiple collapse-tags placeholder="请选择班级" class="filter-select">
              <el-option v-for="item in classlist" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div> -->

          <!-- 知识点题目配置 -->
          <div v-if="randomKnowledgeConfig.length > 0" class="knowledge-config">
            <div v-for="(config, index) in randomKnowledgeConfig" :key="index" class="knowledge-item">
              <div class="knowledge-header">
                <span class="knowledge-title">{{ config.knowledge }}</span>
                <el-button type="text" @click="removeKnowledgeConfig(index)" class="remove-btn">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
              <div class="question-type-config">
                <div v-for="type in quTypeOptions" :key="type.value" class="type-config">
                  <span class="type-label">{{ type.label }}：</span>
                  <el-input-number
                    v-model="config.counts[type.value]"
                    :min="0"
                    :max="20"
                    size="small"
                    @change="updateTotalCount"
                  ></el-input-number>
                </div>
              </div>
            </div>
          </div>

          <!-- 知识点选择 -->
          <div class="filter-row" v-if="randomKnowledgeOptions.length > 0">
            <el-select
              v-model="selectedKnowledge"
              placeholder="请选择知识点"
              class="filter-select"
              @change="addKnowledgeConfig"
            >
              <el-option
                v-for="item in randomKnowledgeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <el-date-picker
            v-model="randomExamTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-ddTHH:mm:ss"
            class="filter-select"
          />
          <div class="filter-row">
            <el-button type="primary" round @click="previewExam" class="filter-btn">预览试卷</el-button>
            <el-button type="success" round @click="generateRandomExam" class="filter-btn">确认生成</el-button>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <!-- 图片上传对话框 -->
    <el-dialog title="上传图片" :visible.sync="imageDialogVisible" width="30%" :before-close="handleImageDialogClose">
      <div class="upload-container">
        <!-- 移除题目类型选择，OCR会自动识别题目类型 -->
        <!-- <div class="question-type-select">
          <span class="label">请选择题目类型：</span>
          <el-radio-group v-model="selectedQuType">
            <el-radio v-for="item in quTypeOptions" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </div> -->
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="handleFileChange"
          :file-list="fileList" :limit="1">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
        </el-upload>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="imageDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleImageUpload">确 定</el-button>
      </div>
    </el-dialog>

    <!-- OCR结果对话框 -->
    <el-dialog title="OCR识别结果" :visible.sync="ocrResultDialogVisible" width="50%">
      <el-table :data="ocrResults" border style="width: 100%">
        <el-table-column prop="content" label="题目内容" />
        <el-table-column prop="answer" label="答案" />
        <el-table-column prop="knowledge" label="知识点" />
        <el-table-column prop="analysis" label="解析" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleAddQuestion(scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 手动输入题目对话框 -->
    <el-dialog title="手动输入题目" :visible.sync="inputDialogVisible" width="50%">
      <el-form :model="inputQuestionForm" label-width="100px">
        <el-form-item label="题目类型">
          <el-select v-model="inputQuestionForm.quType" placeholder="请选择题目类型">
            <el-option v-for="item in quTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="题目内容">
          <el-input type="textarea" v-model="inputQuestionForm.content" :rows="4" placeholder="请输入题目内容" />
        </el-form-item>
        <el-form-item label="答案">
          <el-input type="textarea" v-model="inputQuestionForm.answer" :rows="2" placeholder="请输入答案" />
        </el-form-item>
        <el-form-item label="知识点">
          <el-input v-model="inputQuestionForm.knowledge" placeholder="请输入知识点" />
        </el-form-item>
        <el-form-item label="解析">
          <el-input type="textarea" v-model="inputQuestionForm.analysis" :rows="2" placeholder="请输入解析" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inputDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleInputQuestion">添 加</el-button>
      </span>
    </el-dialog>

    <!-- 通知编辑对话框 -->
    <el-dialog title="编辑通知" :visible.sync="noticeDialogVisible" width="50%">
      <el-form :model="noticeForm" label-width="100px">
        <el-form-item label="通知标题">
          <el-input v-model="noticeForm.title" placeholder="请输入通知标题"></el-input>
        </el-form-item>
        <el-form-item label="通知内容">
          <el-input type="textarea" v-model="noticeForm.content" :rows="4" placeholder="请输入通知内容"></el-input>
        </el-form-item>
        <el-form-item label="是否公开">
          <el-switch
            v-model="noticeForm.isPublic"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="选择班级" v-if="!noticeForm.isPublic">
          <el-select v-model="noticeForm.gradeIds" multiple placeholder="请选择班级">
            <el-option v-for="item in classlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noticeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleNoticeSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 试卷预览对话框 -->
    <el-dialog
      title="试卷预览"
      :visible.sync="previewDialogVisible"
      width="70%"
      :before-close="() => previewDialogVisible = false"
    >
      <div class="preview-content">
        <div v-for="(question, index) in previewQuestions" :key="index" class="question-item">
          <div class="question-header">
            <div class="question-info">
              <span class="question-type">{{ getQuestionTypeName(question.quType) }}</span>
              <span class="question-index">{{ index + 1 }}.</span>
            </div>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              circle
              @click="removeQuestion(index)"
              class="delete-btn"
            ></el-button>
          </div>
          <div class="question-content">{{ question.content }}</div>
          <div class="question-answer" v-if="question.answer">
            <div class="answer-label">答案：</div>
            <div class="answer-content">{{ question.answer }}</div>
          </div>
          <div class="question-analysis" v-if="question.analysis">
            <div class="analysis-label">解析：</div>
            <div class="analysis-content">{{ question.analysis }}</div>
          </div>
        </div>
      </div>
      <div class="preview-footer">
        <div class="question-stats">
          <span>总题数：{{ previewQuestions.length }}</span>
          <span v-for="(count, type) in getQuestionTypeCounts()" :key="type" class="type-count">
            {{ getQuestionTypeName(type) }}：{{ count }}题
          </span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="previewDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmGenerateExam">确认生成</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getKnowledgeOptions } from '@/api/knowledge'
import { noticeAdd, noticeGetNew } from '@/api/notice'
import { addQuestion } from '@/api/question'
import { processOcrImage } from '@/api/ai'
import { getQuestionsByKnowledge, getKnowledgeContent, generateExam, examAdd, saveData, addExamquestions } from '@/api/exam'
import { classPaging } from '@/api/class'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { upload } from '@/utils/request1'

export default {
  name: 'homework-question',
  data() {
    return {
      value5: [],
      classlist: [],
      typevalue: [],
      tableData: [],
      selectedTableData: [],
      allSelectedQuestions: [],
      testdata: [
        {
          'suboptions': '数学',
          'textbookOptions': '人教版',
          'gradeoptions': 3
        }
      ],
      testdata1: [
        {
          'knowledge': ''
        }
      ],
      typeOptions: [
        { value: '作业本', label: '作业本' },
        { value: '模拟卷', label: '模拟卷' }
      ],
      suboptions: [
        { value: '语文', label: '语文' },
        { value: '数学', label: '数学' },
        { value: '英语', label: '英语' }
      ],
      textbookOptions: [
        { value: '人教版', label: '人教版' },
        { value: '苏教版', label: '苏教版' },
        { value: '北师大版', label: '北师大版' },
        { value: '西师大版', label: '西师大版' },
        { value: '冀教版', label: '冀教版' },
        { value: '沪教版', label: '沪教版' },
        { value: '青岛版', label: '青岛版' },
        { value: '浙教版', label: '浙教版' },
        { value: '北京版', label: '北京版' }
      ],
      gradeoptions: [
        { value: 1, label: '一年级' },
        { value: 2, label: '二年级' },
        { value: 3, label: '三年级' },
        { value: 4, label: '四年级' },
        { value: 5, label: '五年级' },
        { value: 6, label: '六年级' }
      ],
      knowledgeoptions: [],
      value1: [],
      value2: [],
      value3: [],
      value4: [],
      textarea: '',
      imageDialogVisible: false,
      ocrResultDialogVisible: false,
      fileList: [],
      ocrResults: [],
      selectedQuType: '',
      quTypeOptions: [
        { value: 1, label: '选择题', type: 'select' },
        { value: 2, label: '填空题', type: 'fill' },
        { value: 3, label: '判断题', type: 'judge' },
        { value: 4, label: '简答题', type: 'application' }
      ],
      inputDialogVisible: false,
      inputQuestionForm: {
        quType: '',
        content: '',
        answer: '',
        knowledge: '',
        analysis: ''
      },
      examTitle: '',
      examTime: [],
      noticeDialogVisible: false,
      noticeForm: {
        title: '',
        content: '',
        isPublic: 0,
        gradeIds: []
      },
      activeTab: 'manual',
      randomExamTitle: '',
      randomTypeValue: '',
      randomValue1: '',
      randomValue2: '',
      randomValue3: '',
      randomValue4: [],
      randomValue5: [],
      randomConfig: {
        radioCount: 0,
        multiCount: 0,
        judgeCount: 0,
        saqCount: 0
      },
      randomExamTime: [],
      randomKnowledgeConfig: [],
      randomKnowledgeOptions: [],
      selectedKnowledge: '',
      previewDialogVisible: false,
      previewQuestions: [],
      filterQuType: ''
    }
  },
  computed: {
    filteredTableData() {
      if (!this.filterQuType) return this.tableData;
      return this.tableData.filter(q => q.quType === this.filterQuType);
    }
  },
  mounted() {
    // this.fetchKnowledgeOptions();
    // 声明为async函数
    (async () => {
      try {
        const params = {
          pageNum: 1,
          pageSize: 100 // 获取足够多的班级数据
        }
        const response = await classPaging(params)
        if (response.code === 1 && response.data) {
          this.classlist = response.data.records.map(item => ({
            value: item.id,
            label: item.gradeName
          }))
        } else {
          this.$message.error('获取班级列表失败')
        }
      } catch (error) {
        console.error('获取班级列表失败:', error)
        this.$message.error('获取班级列表失败')
      }
    })()
  },
  methods: {
    async uploadexamquestion() {
      if (!this.examTitle) {
        this.$message.warning('请输入考试名称')
        return
      }

      if (this.selectedTableData.length === 0) {
        this.$message.warning('请选择要发布的题目')
        return
      }

      if (!this.examTime || this.examTime.length !== 2) {
        this.$message.warning('请选择考试时间范围')
        return
      }

      // 统计各类型题目的数量
      const typeCounts = {
        1: 0, // 单选题
        2: 0, // 多选题
        3: 0, // 判断题
        4: 0 // 简答题
      }

      // 计算每种题型的数量
      this.selectedTableData.forEach(question => {
        typeCounts[question.quType]++
      })

      // 计算每种题型的分数
      const calculateScores = () => {
        const totalQuestions = this.selectedTableData.length
        if (totalQuestions === 0) return {}

        // 简答题权重更高
        const weights = {
          1: 1, // 单选题
          2: 1, // 多选题
          3: 1, // 判断题
          4: 2 // 简答题权重加倍
        }

        // 计算总权重
        let totalWeight = 0
        for (const type in typeCounts) {
          totalWeight += typeCounts[type] * weights[type]
        }

        // 计算每种题型的每道题分数
        const scores = {}
        for (const type in typeCounts) {
          if (typeCounts[type] > 0) {
            // 根据权重分配分数，并四舍五入到最接近的整数
            scores[type] = Math.round((100 * weights[type]) / totalWeight)
          }
        }

        // 确保总分不超过100
        let currentTotal = 0
        for (const type in scores) {
          currentTotal += scores[type] * typeCounts[type]
        }

        if (currentTotal > 100) {
          // 如果总分超过100，按比例减少分数
          const ratio = 100 / currentTotal
          for (const type in scores) {
            scores[type] = Math.round(scores[type] * ratio)
          }
        }

        return scores
      }

      const typeScores = calculateScores()

      // 处理选中的题目，生成questions数组
      const questions = this.selectedTableData.map((question, index) => {
        return {
          questionId: question.id,
          score: typeScores[question.quType],
          sort: index + 1,
          type: question.quType
        }
      })

      const examData = {
        radioScore: typeScores[1] || 0, // 单选题分数
        passedScore: 60, // 及格分
        examDuration: 120, // 考试时长（分钟）
        saqScore: typeScores[4] || 0, // 简答题分数
        multiScore: typeScores[2] || 0, // 多选题分数
        judgeScore: typeScores[3] || 0, // 判断题分数
        repoId: 7, // 题库ID
        title: this.examTitle,
        gradeIds: this.value5.join(','),
        startTime: this.examTime[0],
        endTime: this.examTime[1],
        duration: 120,
        radioCount: typeCounts[1],
        multiCount: typeCounts[2],
        judgeCount: typeCounts[3],
        saqCount: typeCounts[4],
        questions: questions
      }

      try {
        // 调用保存考试的方法
        const saveResponse = await saveData(examData)
        if (saveResponse.code === 1) {
          // 打开通知编辑对话框
          this.noticeForm = {
            title: `${this.examTitle}`,
            content: `新的考试"${this.examTitle}"已发布，请及时查看。\n考试时间：${this.examTime[0]} 至 ${this.examTime[1]}\n考试时长：120分钟`,
            isPublic: 0,
            gradeIds: this.value5
          }
          this.noticeDialogVisible = true
        } else {
          this.$message.error(saveResponse.message || '考试发布失败')
        }
      } catch (error) {
        console.error('发布考试失败:', error)
        this.$message.error('发布考试失败')
      }
    },

    async testexam(examData) {
      try {
        const response = await saveData(examData)
        if (response.code === 1) {
          this.$message.success('考试发布成功')
        } else {
          this.$message.error(response.message || '考试发布失败')
        }
      } catch (error) {
        console.error('添加考试失败:', error)
        this.$message.error('添加考试失败')
      }
    },
    // 录入题目
    handlestem() {
      this.imageDialogVisible = true;
      this.fileList = [];
    },

    // 处理文件变化
    handleFileChange(file) {
      this.fileList = [file];
    },

    // 将后端返回的题目类型字符串转换为前端使用的数字类型
    convertQuestionType(backendType) {
      const typeMapping = {
        'select': 1,
        'fill': 2,
        'judge': 3,
        'application': 4,
        'short_answer': 4, // 简答题对应application类型
        'multiple_choice': 1, // 选择题
        'true_false': 3, // 判断题
        'fill_blank': 2 // 填空题
      };
      return typeMapping[backendType] || 1; // 默认返回选择题类型
    },

    // 处理图片上传
    handleImageUpload() {
      if (this.fileList && this.fileList.length > 0) {
        const loadingInstance = this.$loading({
          lock: true,
          text: 'OCR识别中，请稍后...',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        const formData = new FormData();
        formData.append('image', this.fileList[0].raw);

        processOcrImage(formData)
          .then((response) => {
            loadingInstance.close();
            console.log('OCR原始返回：', response);

            const questions = response.questions;
            if (Array.isArray(questions)) {
              this.ocrResults = questions.map(question => {
                return {
                  content: question.question_content || '',
                  answer: question.answer || '',
                  knowledge: '', // 后端没有返回knowledge字段，设为空字符串
                  analysis: question.explanation || '',
                  type: this.convertQuestionType(question.question_type)
                };
              });
              this.$message.success('OCR识别成功！');
              this.imageDialogVisible = false;
              this.ocrResultDialogVisible = true;
            } else {
              console.error('返回的数据格式不正确：', response);
              this.$message.error('返回的数据格式不正确');
            }
          })
          .catch((error) => {
            loadingInstance.close();
            console.error('OCR识别失败：', error);
            this.$message.error('OCR识别失败：' + (error.message || '未知错误'));
          });
      } else {
        this.$message.warning('请选择图片后再上传！');
      }
    },

    // 处理图片对话框关闭
    handleImageDialogClose(done) {
      this.fileList = [];
      done();
    },

    // 添加题目到表格
    handleAddQuestion(question) {
      const newQuestion = {
        id: Date.now(), // 临时ID
        quType: question.type,
        content: question.content,
        chapter: question.knowledge || '未分类',
        answer: question.answer,
        analysis: question.analysis
      };

      // 添加到表格数据中
      this.tableData.push(newQuestion);

      // 自动选中新添加的题目
      this.$nextTick(() => {
        const row = this.tableData.find(item => item.id === newQuestion.id);
        if (row) {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        }
      });

      this.$message.success('题目添加成功！');

      // 关闭OCR结果对话框
      this.ocrResultDialogVisible = false;
    },
    async printTableToPdf() {
      // 组装题目数据
      const questionTypeMap = {
        1: '选择题',
        2: '填空题',
        3: '判断题',
        4: '简答题'
      }
      const questionData = this.selectedTableData.map(q => ({
        type: questionTypeMap[q.quType] || '未知题型',
        question: q.content,
        score: q.score || 5 // 默认 5 分
      }))

      // 组装请求体
      const requestData = {
        upload_questions: {
          paper_type: this.typevalue[0],
          exam_title: this.examTitle,
          student_info: {
            student_num: '',
            name: ''
          },
          questionData
        }
      }

      try {
        const response = await generateExam(requestData)
        // 创建 Blob 对象
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
        // 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = downloadUrl
        link.download = '考试试卷.docx'
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 100)
        this.$message.success('试卷生成成功，开始下载')
      } catch (error) {
        this.$message.error('生成试卷失败，请稍后重试')
        console.error(error)
      }
    },
    handleSelectionChange(val) {
      this.selectedTableData = val

      this.allSelectedQuestions = this.allSelectedQuestions.filter(selectedQuestion => {
        const isInCurrentTable = this.tableData.some(q => q.id === selectedQuestion.id)
        const isStillSelected = val.some(q => q.id === selectedQuestion.id)
        return !isInCurrentTable || isStillSelected
      })

      val.forEach(newQuestion => {
        if (!this.allSelectedQuestions.some(q => q.id === newQuestion.id)) {
          this.allSelectedQuestions.push(newQuestion)
        }
      })

      this.updateSelectedTableData()
    },

    updateSelectedTableData() {
      this.selectedTableData = [...this.allSelectedQuestions]
    },

    toggleSelection() {
      this.allSelectedQuestions = []
      this.selectedTableData = []
      this.$refs.multipleTable.clearSelection()
    },

    async testget() {
      if (!this.value4 || this.value4.length === 0) {
        this.$message.warning('请先选择知识点')
        return
      }

      this.testdata1[0].knowledge = this.value4.join(',')
      console.log('knowledge的值是：', this.testdata1[0].knowledge)

      try {
        const response = await getQuestionsByKnowledge(this.testdata1[0])
        console.log('API响应数据：', response)
        if (response && response.code === 1 && Array.isArray(response.data)) {
          this.tableData = response.data.map(item => ({
            id: item.id,
            quType: item.quType,
            content: item.content,
            chapter: item.chapter || '未分类'
          }))

          this.$nextTick(() => {
            this.tableData.forEach(row => {
              if (this.allSelectedQuestions.some(q => q.id === row.id)) {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            })
          })
        } else {
          console.error('返回的数据格式不正确:', response)
          this.tableData = []
        }
        console.log('处理后的表格数据：', this.tableData)
      } catch (error) {
        console.error('获取题目列表失败:', error)
        this.tableData = []
      }
    },
    convertAI() {
      this.$router.push('/useAI')
    },
    async testKnowledgeOptions() {
      console.log(this.testdata)
      try {
        const response = await getKnowledgeContent(this.testdata[0])
        console.log(response)
      } catch (error) {
        console.error('获取知识点内容失败:', error)
      }
    },
    async fetchKnowledgeOptions() {
      try {
        const params = [{
          suboptions: this.value2[0],
          textbookOptions: this.value1[0],
          gradeoptions: this.value3[0]
        }]
        const response = await getKnowledgeOptions(params[0])
        this.knowledgeoptions = response.data.map(item => ({
          value: item.content,
          label: item.content
        }))
      } catch (error) {
        console.error('获取知识点选项失败:', error)
      }
    },
    inputstem() {
      this.inputDialogVisible = true
      // 重置表单
      this.inputQuestionForm = {
        quType: '',
        content: '',
        answer: '',
        knowledge: '',
        analysis: ''
      }
    },

    handleInputQuestion() {
      // 验证必填字段
      if (!this.inputQuestionForm.quType) {
        this.$message.warning('请选择题目类型')
        return
      }
      if (!this.inputQuestionForm.content) {
        this.$message.warning('请输入题目内容')
        return
      }

      // 创建新题目对象
      const newQuestion = {
        id: Date.now(), // 临时ID
        quType: this.inputQuestionForm.quType,
        content: this.inputQuestionForm.content,
        chapter: this.inputQuestionForm.knowledge || '未分类',
        answer: this.inputQuestionForm.answer,
        analysis: this.inputQuestionForm.analysis
      }

      // 添加到表格数据中
      this.tableData.push(newQuestion)

      // 自动选中新添加的题目
      this.$nextTick(() => {
        const row = this.tableData.find(item => item.id === newQuestion.id)
        if (row) {
          this.$refs.multipleTable.toggleRowSelection(row, true)
        }
      })

      this.$message.success('题目添加成功！')
      this.inputDialogVisible = false
    },

    async handleNoticeSubmit() {
      try {
        if (!this.noticeForm.title || !this.noticeForm.content) {
          this.$message.warning('请填写完整的通知信息')
          return
        }

        if (!this.noticeForm.isPublic && (!this.noticeForm.gradeIds || this.noticeForm.gradeIds.length === 0)) {
          this.$message.warning('请选择接收通知的班级')
          return
        }

        const noticeData = {
          title: this.noticeForm.title,
          content: this.noticeForm.content,
          isPublic: this.noticeForm.isPublic,
          gradeIds: this.noticeForm.isPublic === 1 ? '' : this.noticeForm.gradeIds.join(',')
        }

        const response = await noticeAdd(noticeData)
        if (response.code === 1) {
          this.$message.success('通知发布成功')
          this.noticeDialogVisible = false
        } else {
          this.$message.error(response.message || '通知发布失败')
        }
      } catch (error) {
        console.error('发布通知失败:', error)
        this.$message.error('发布通知失败')
      }
    },

    async fetchRandomKnowledgeOptions() {
      if (!this.randomValue1 || !this.randomValue2 || !this.randomValue3) {
        this.$message.warning('请先选择教材、科目和年级')
        return
      }

      try {
        const response = await getKnowledgeOptions({
          suboptions: this.randomValue2,
          textbookOptions: this.randomValue1,
          gradeoptions: this.randomValue3
        })
        this.randomKnowledgeOptions = response.data.map(item => ({
          value: item.content,
          label: item.content
        }))
      } catch (error) {
        console.error('获取随机知识点选项失败:', error)
        this.$message.error('获取知识点失败')
      }
    },

    removeKnowledgeConfig(index) {
      this.randomKnowledgeConfig.splice(index, 1)
      this.updateTotalCount()
    },

    updateTotalCount() {
      // 计算每种题型的总数
      const totalCounts = {
        1: 0, // 单选题
        2: 0, // 多选题
        3: 0, // 判断题
        4: 0 // 简答题
      }

      this.randomKnowledgeConfig.forEach(config => {
        Object.keys(config.counts).forEach(type => {
          totalCounts[type] += config.counts[type] || 0
        })
      })

      return totalCounts
    },

    addKnowledgeConfig() {
      if (!this.selectedKnowledge) return

      // 检查是否已经添加过该知识点
      if (this.randomKnowledgeConfig.some(config => config.knowledge === this.selectedKnowledge)) {
        this.$message.warning('该知识点已添加')
        return
      }

      // 显示加载提示
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在获取知识点试题...',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 查询该知识点的试题
      this.fetchQuestionsByKnowledge(this.selectedKnowledge)
        .then(questions => {
          console.log('获取到的试题:', questions) // 添加日志
          // 添加新的知识点配置
          this.randomKnowledgeConfig.push({
            knowledge: this.selectedKnowledge,
            counts: {
              1: 0, // 单选题
              2: 0, // 多选题
              3: 0, // 判断题
              4: 0 // 简答题
            },
            questions: questions // 存储该知识点的所有试题
          })

          // 清空选择
          this.selectedKnowledge = ''

          // 关闭加载提示
          loadingInstance.close()
        })
        .catch(error => {
          console.error('获取试题失败:', error)
          this.$message.error('获取试题失败')
          loadingInstance.close()
        })
    },

    async fetchQuestionsByKnowledge(knowledge) {
      try {
        console.log('正在获取知识点试题:', knowledge) // 添加日志
        const params = {
          knowledge: knowledge
        }
        console.log('请求参数:', params) // 添加日志
        const response = await getQuestionsByKnowledge(params)
        console.log('API响应:', response) // 添加日志
        if (response && response.code === 1 && Array.isArray(response.data)) {
          return response.data
        }
        return []
      } catch (error) {
        console.error('获取知识点试题失败:', error)
        this.$message.error('获取知识点试题失败')
        return []
      }
    },

    async generateRandomExam() {
      if (!this.randomExamTitle) {
        this.$message.warning('请输入考试名称')
        return
      }

      if (!this.randomTypeValue || !this.randomValue1 || !this.randomValue2 || !this.randomValue3) {
        this.$message.warning('请选择完整的考试类型、教材、科目和年级')
        return
      }

      if (this.randomKnowledgeConfig.length === 0) {
        this.$message.warning('请至少添加一个知识点并设置题目数量')
        return
      }

      if (!this.randomValue5) {
        this.$message.warning('请选择班级')
        return
      }

      if (!this.randomExamTime || this.randomExamTime.length !== 2) {
        this.$message.warning('请选择考试时间范围')
        return
      }

      const totalCounts = this.updateTotalCount()
      const totalQuestions = Object.values(totalCounts).reduce((sum, count) => sum + count, 0)

      if (totalQuestions === 0) {
        this.$message.warning('请设置至少一种题型的题目数量')
        return
      }

      try {
        // 计算每种题型的分数
        const calculateScores = () => {
          const totalQuestions = this.previewQuestions.length
          if (totalQuestions === 0) return {}

          // 简答题权重更高
          const weights = {
            1: 1, // 单选题
            2: 1, // 多选题
            3: 1, // 判断题
            4: 2 // 简答题权重加倍
          }

          // 计算总权重
          let totalWeight = 0
          for (const type in totalCounts) {
            totalWeight += totalCounts[type] * weights[type]
          }

          // 计算每种题型的每道题分数
          const scores = {}
          for (const type in totalCounts) {
            if (totalCounts[type] > 0) {
              // 根据权重分配分数，并四舍五入到最接近的整数
              scores[type] = Math.round((100 * weights[type]) / totalWeight)
            }
          }

          // 确保总分不超过100
          let currentTotal = 0
          for (const type in scores) {
            currentTotal += scores[type] * totalCounts[type]
          }

          if (currentTotal > 100) {
            // 如果总分超过100，按比例减少分数
            const ratio = 100 / currentTotal
            for (const type in scores) {
              scores[type] = Math.round(scores[type] * ratio)
            }
          }

          return scores
        }

        const typeScores = calculateScores()

        // 构建随机组卷请求参数
        const examData = {
          title: this.randomExamTitle,
          gradeIds: this.randomValue5,
          startTime: this.randomExamTime[0],
          endTime: this.randomExamTime[1],
          duration: 120,
          examDuration: 120,
          passedScore: 60,
          repoId: 7,
          radioCount: totalCounts[1] || 0,
          multiCount: totalCounts[2] || 0,
          judgeCount: totalCounts[3] || 0,
          saqCount: totalCounts[4] || 0,
          radioScore: typeScores[1] || 0,
          multiScore: typeScores[2] || 0,
          judgeScore: typeScores[3] || 0,
          saqScore: typeScores[4] || 0,
          questions: this.previewQuestions.map((question, index) => ({
            questionId: question.id,
            score: typeScores[question.quType],
            sort: index + 1,
            type: question.quType
          }))
        }

        // 调用保存考试的方法
        const saveResponse = await saveData(examData)
        if (saveResponse.code === 1) {
          // 打开通知编辑对话框
          this.noticeForm = {
            title: `${this.randomExamTitle}`,
            content: `新的考试"${this.randomExamTitle}"已发布，请及时查看。\n考试时间：${this.randomExamTime[0]} 至 ${this.randomExamTime[1]}\n考试时长：120分钟`,
            isPublic: 0,
            gradeIds: [this.randomValue5]
          }
          this.noticeDialogVisible = true
          this.$message.success('随机试卷生成成功')
        } else {
          this.$message.error(saveResponse.message || '随机试卷生成失败')
        }
      } catch (error) {
        console.error('生成随机试卷失败:', error)
        this.$message.error('生成随机试卷失败')
      }
    },

    getQuestionTypeName(type) {
      const typeMap = {
        1: '单选题',
        2: '多选题',
        3: '判断题',
        4: '简答题'
      }
      return typeMap[type] || '未知题型'
    },

    // 随机抽取试题
    selectRandomQuestions(config) {
      const selectedQuestions = []
      const questions = config.questions || []

      // 按题型分组
      const questionsByType = {
        1: [], // 单选题
        2: [], // 多选题
        3: [], // 判断题
        4: [] // 简答题
      }

      // 将试题按类型分组
      questions.forEach(q => {
        if (questionsByType[q.quType]) {
          questionsByType[q.quType].push(q)
        }
      })

      // 从每种题型中随机抽取指定数量的题目
      Object.entries(config.counts).forEach(([type, count]) => {
        const typeQuestions = questionsByType[type] || []
        if (count > 0 && typeQuestions.length > 0) {
          // 随机打乱题目顺序
          const shuffled = [...typeQuestions].sort(() => 0.5 - Math.random())
          // 取前count个题目
          selectedQuestions.push(...shuffled.slice(0, count))
        }
      })

      return selectedQuestions
    },

    // 预览试卷
    previewExam() {
      if (this.randomKnowledgeConfig.length === 0) {
        this.$message.warning('请先添加知识点并设置题目数量')
        return
      }

      // 从每个知识点中随机抽取题目
      const allSelectedQuestions = []
      this.randomKnowledgeConfig.forEach(config => {
        const selectedQuestions = this.selectRandomQuestions(config)
        allSelectedQuestions.push(...selectedQuestions)
      })

      // 按题型排序
      allSelectedQuestions.sort((a, b) => a.quType - b.quType)

      // 显示预览对话框
      this.previewDialogVisible = true
      this.previewQuestions = allSelectedQuestions
    },

    // 确认生成试卷
    confirmGenerateExam() {
      if (!this.previewQuestions || this.previewQuestions.length === 0) {
        this.$message.warning('没有可用的试题')
        return
      }

      // 更新知识点配置中的题目
      this.randomKnowledgeConfig.forEach(config => {
        config.selectedQuestions = this.previewQuestions.filter(q =>
          q.knowledge === config.knowledge
        )
      })

      this.generateRandomExam()
    },

    // 删除预览中的题目
    removeQuestion(index) {
      this.$confirm('确定要删除这道题目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.previewQuestions.splice(index, 1)
        this.$message.success('题目已删除')
      }).catch(() => {})
    },

    // 获取各类型题目的数量
    getQuestionTypeCounts() {
      const counts = {
        1: 0, // 单选题
        2: 0, // 多选题
        3: 0, // 判断题
        4: 0 // 简答题
      }

      this.previewQuestions.forEach(question => {
        counts[question.quType]++
      })

      return counts
    },

    getSelectedTypeCounts() {
      const counts = {};
      this.quTypeOptions.forEach(opt => {
        counts[opt.value] = 0;
      });
      this.selectedTableData.forEach(q => {
        if (counts[q.quType] !== undefined) {
          counts[q.quType]++;
        }
      });
      return counts;
    }
  }
}
</script>
<style scoped>
.ai-exam-container {
  padding: 30px 30px 80px 30px;
  background: #f7f8fa;
  min-height: 100vh;
}

.filter-card {
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.filter-title-row {
  margin-bottom: 8px;
}

.filter-title-row h2 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 12px;
}

.filter-select,
.filter-btn {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

.filter-btn {
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
}

.table-flex-row {
  display: flex;
  gap: 24px;
  margin-top: 10px;
}

.table-card {
  flex: 1;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-width: 420px;
  background: #fff;
}

.table-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #409EFF;
}

.button-float {
  position: fixed;
  bottom: 30px;
  right: 40px;
  display: flex;
  gap: 18px;
  z-index: 100;
}

.upload-demo {
  text-align: center;
}

.dialog-footer {
  text-align: right;
}

.upload-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.question-type-select {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.question-type-select .label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-radio {
  margin-right: 0;
}

.filter-select {
  margin-right: 10px;
  width: 200px;
}

.knowledge-config {
  margin: 20px 0;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 10px;
}

.knowledge-item {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #F5F7FA;
  border-radius: 4px;
}

.knowledge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.knowledge-title {
  font-weight: bold;
  color: #303133;
}

.remove-btn {
  color: #F56C6C;
}

.question-type-config {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.type-config {
  display: flex;
  align-items: center;
  gap: 8px;
}

.type-label {
  min-width: 60px;
  color: #606266;
}

.preview-content {
  max-height: 600px;
  overflow-y: auto;
  padding: 20px;
}

.question-item {
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background-color: #F5F7FA;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.question-info {
  display: flex;
  align-items: center;
}

.delete-btn {
  opacity: 0.7;
  transition: opacity 0.3s;
}

.delete-btn:hover {
  opacity: 1;
}

.preview-footer {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #EBEEF5;
}

.question-stats {
  margin-bottom: 15px;
  color: #606266;
}

.type-count {
  margin-left: 20px;
  color: #409EFF;
}

.question-stats span {
  font-size: 14px;
}
</style>
